import { render, staticRenderFns } from "./GateDamageSeverity.vue?vue&type=template&id=adc33b18&scoped=true"
import script from "./GateDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./GateDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc33b18",
  null
  
)

export default component.exports